<!-- components/SearchBox.vue -->
<template>
  <div class="search-box-container">
    <input
      type="search"
      v-model="localQuery"
      @input="onInput"
      @keydown.enter.prevent="onEnter"
      :class="inputClass"
      :placeholder="placeholder"
      :aria-label="ariaLabel"
      :aria-describedby="ariaDescribedBy"
    />
    <div
      class="spinner-border text-primary mb-1 spinner"
      role="status"
      v-show="isSearchStalled"
    >
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SearchBox',
  props: {
    query: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: 'Search...',
    },
    ariaLabel: {
      type: String,
      default: 'Search',
    },
    ariaDescribedBy: {
      type: String,
      default: '',
    },
    inputClass: {
      type: String,
      default: 'form-control',
    },
    isSearchStalled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localQuery: this.query,
    };
  },
  watch: {
    query(newValue) {
      this.localQuery = newValue;
    },
  },
  methods: {
    onInput() {
      this.$emit('input', this.localQuery);
    },
    onEnter() {
      this.$emit('search', this.localQuery);
    },
  },
};
</script>

<style scoped>
.search-box-container {
  position: relative;
}

.spinner {
  position: absolute;
  top: 13px;
  right: 17px;
}
</style>